module.exports = __webpack_public_path__ + "img/banner1-En1.70f14dbc.jpg";